import { useTheme } from '@mui/material';

export const useSxStyles = () => {
  const theme = useTheme();

  return {
    errorMessage: {
      padding: theme.spacing(0, 2),
    },
  };
};
